import React, { useId } from 'react';

interface ClippyIconProps {
  busy?: boolean;
  height?: number;
}

// Hand-drawn Clippy-style paperclip with eyes - bounces while Copilot is working
const ClippyIcon: React.FC<ClippyIconProps> = ({ busy = false, height = 56 }) => {
  // Unique gradient id - Clippy can be on screen more than once
  const gradientId = `clippy-wire-${useId().replace(/:/g, '')}`;

  return (
    <svg
      className={`clippy-icon${busy ? ' is-busy' : ''}`}
      viewBox="0 0 36 68"
      width={Math.round((height * 36) / 68)}
      height={height}
      role="img"
      aria-label="Clippy"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#6f7782" />
          <stop offset="50%" stopColor="#c3c8cf" />
          <stop offset="100%" stopColor="#6f7782" />
        </linearGradient>
      </defs>

      {/* Paperclip wire */}
      <path
        d="M24 44 V18 a6 6 0 0 0 -12 0 V54 a9 9 0 0 0 18 0 V14 a12 12 0 0 0 -24 0 V48"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Eyebrows */}
      <path d="M6 16 q5 -4 10 -1" fill="none" stroke="#262420" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M20 15 q5 -3 10 1" fill="none" stroke="#262420" strokeWidth="1.6" strokeLinecap="round" />

      {/* Eyes */}
      <circle cx="11" cy="23" r="5" fill="#ffffff" stroke="#262420" strokeWidth="1" />
      <circle cx="25" cy="23" r="5" fill="#ffffff" stroke="#262420" strokeWidth="1" />
      <circle className="clippy-pupil" cx="12.5" cy="22" r="2.2" fill="#262420" />
      <circle className="clippy-pupil" cx="26.5" cy="22" r="2.2" fill="#262420" />
    </svg>
  );
};

export default ClippyIcon;
